// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"Sidebar_linkContainer__2-rmb","linkText":"Sidebar_linkText__FGND1"};